import { createFileRoute } from "@tanstack/react-router";

import { FlowFinancing } from "~/components/feature/flow/components";

export const Route = createFileRoute("/_app/dashboard/flow/financing")({
  component: RouteComponent,
});

function RouteComponent() {
  return <FlowFinancing />;
}
